<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
/**
 * Dashboard Component
 */
export default {
  name: 'purchase.dashboard',
  page: {
    title: 'Purchase - Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      title: 'Purchase Dashboard'
    }
  },

  computed: {
    breadcrumbs () {
      return [
        {
          text: 'Purchase',
          to: { name: 'purchase' }
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs" />

    <!-- end row -->
  </Layout>
</template>
